import { fetchWithAdmin } from './fetchHelper';

/** The BuzzBrain app report — backend `admin/analytics/appUsage.ts`. */
export interface AppUsage {
  from: string;
  to: string;
  totals: {
    people: number; activeDays: number; answers: number; hints: number;
    solutionViews: number; conceptLabs: number; textChats: number;
  };
  trend: { date: string; people: number; answers: number; hints: number }[];
  practice: {
    active: number; answered: number; answeredOn2Days: number; usedHint: number;
    viewedSolution: number; cameBack: number; signedUp: number;
  };
  links: { slug: string; opens: number; accounts: number; active: number; answered: number; cameBack: number; signedUp: number }[];
  sessions: {
    sessions: number;
    peopleWithSessions: number;
    landings: { landing: string; sessions: number; people: number; answers: number }[];
  };
  filterOptions: Record<AppFilterKey, { value: string; people: number }[]>;
  excludedAccounts: number;
  scienceReaders: number;
  /** Screens used in recorded sessions — absent from a backend before them. */
  screens?: { path: string; users: number; sessions: number; views: number }[];
  /** Every student in the report by first-touch source. */
  sources?: { source: string; students: number; answered: number; cameBack: number; signedUp: number }[];
}

export type AppFilterKey = 'source' | 'campaign' | 'link' | 'platform';

/** The person filters the app report takes; keys shared with the science
 *  site's (who, source, campaign, returning) mean the same thing there. */
export const APP_FILTER_KEYS = ['who', 'source', 'campaign', 'link', 'returning', 'platform'] as const;

export const appUsageApi = {
  get: (from: Date, to: Date, filters: Record<string, string>) =>
    fetchWithAdmin<AppUsage>(
      `/console/app-usage?from=${encodeURIComponent(from.toISOString())}`
      + `&to=${encodeURIComponent(to.toISOString())}`
      + APP_FILTER_KEYS
        .filter(k => filters[k])
        .map(k => `&${k}=${encodeURIComponent(filters[k])}`)
        .join(''),
    ),
};
